import { FormValidators, VALIDATION_MESSAGES } from '../../hooks/useForm';
import { ExternalUserShort } from '../../types/externalUser';
import { isBlankHtml } from '../../utils/validationUtils';

const { NOT_USERS, NOT_SUBJECT, NOT_CONTENT } = VALIDATION_MESSAGES;

export interface PromotionsForm {
  users: ExternalUserShort[];
  subject: string;
  content: string;
}

export const PROMOTIONS_FORM_VALIDATORS: FormValidators<PromotionsForm> = {
  users: (form) => {
    if (!form.users || form.users.length === 0) return NOT_USERS;
  },
  subject: (form) => {
    if (!form.subject) return NOT_SUBJECT;
  },
  content: (form) => {
    if (isBlankHtml(form.content)) return NOT_CONTENT;
  },
};
